module.exports = __webpack_public_path__ + "img/ExpandDown.8e4a895d.svg";